import Entity from '../../../core/domain/entity';
import UniqueEntityID from '../../../core/domain/unique_entity_id';

export interface FaqHelpProps {
  target?: string;
  title?: string;
  content?: string;
  sort?: string;
}

export class FaqHelpId extends Entity<unknown> {
  private constructor(id?: UniqueEntityID) {
    super(null, id);
  }

  public static create(id?: UniqueEntityID): FaqHelpId {
    return new FaqHelpId(id);
  }
}

export class FaqHelp extends Entity<FaqHelpProps> {
  get faqHelpId(): FaqHelpId {
    return FaqHelpId.create(this.id);
  }

  get target() {
    return this.props.target;
  }

  set target(value: string | undefined) {
    this.props.target = value;
  }

  get title() {
    return this.props.title;
  }

  set title(value: string | undefined) {
    this.props.title = value;
  }

  get content() {
    return this.props.content;
  }

  set content(value: string | undefined) {
    this.props.content = value;
  }

  get sort(): string | undefined {
    return this.props.sort;
  }

  set sort(value: string | undefined) {
    this.props.sort = value;
  }

  private constructor(props: FaqHelpProps, id?: UniqueEntityID) {
    super(props, id);
  }

  copyWith(props: FaqHelpProps): FaqHelp {
    return FaqHelp.create(
      {
        ...this.props,
        ...props,
      },
      this.id,
    );
  }

  public static create(props: FaqHelpProps, id?: UniqueEntityID): FaqHelp {
    return new FaqHelp(props, id);
  }
}
